import { render, staticRenderFns } from "./PayInvestment.vue?vue&type=template&id=2a330c10"
import script from "./PayInvestment.vue?vue&type=script&lang=js"
export * from "./PayInvestment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports